export default {
  geoDataIsReady: (state) => state.applicationState.geo.cities.isReady && state.applicationState.geo.localities.isReady,
  cities: (state) => state.applicationState.geo.cities.data,
  localities: (state) => state.applicationState.geo.localities.data,
};
